<template>
	<div class="introduceView">
		<div class="svg">
			<img :src="honorImg" style="width: 45px;"/>
			<!-- <SvgIcon :svg-name="svgName" size="45"></SvgIcon> -->
		</div>
		<div class="introduceView-img">
			<img :src="imgUrl" />
		</div>
		<div class="introduceView-name">{{name}}</div>
	</div>
</template>

<script>
	
	import SvgIcon from './SvgIcon.vue'
	
	export default{
		name:'introduceView',
		props:{
			name:{
				type:String,
			},
			imgUrl:{
				// type:Array,
			},
			svgName:{
				type:String,
			},
			honorImg: {
				// type:Array,
			}
		},
		components:{
			SvgIcon,
			
		}
	}
	
</script>

<style>
	.introduceView{
		width: 100%;
		max-width: 11.875rem;
		margin-top: 2.025rem;
		position: relative;
		/* height: 2.125rem; */
	}
	
	.svg{
		position:absolute;
		left:18%;
		top: 5%;
	}
	
	.introduceView .introduceView-img{
		margin: 0 auto;
		background-color: rgba(244,244,244,1);
		width: 80%;
		height: 9.375rem;
		height: ;
	}
	
	.introduceView .introduceView-img img{
		width: 60%;
		/* max-width: 2.5rem; */
		/* height:  60%; */
		height: auto;
		margin:0 auto;
		margin-top: 2.025rem;
	}
	
	.introduceView .introduceView-name{
		margin-top: 0.625rem;
		color:rgba(17,17,17,1);
		font-size: 0.65rem;
		font-family:Alibaba-PuHuiTi-R;
	}
</style>
